module.exports = __webpack_public_path__ + "eddedb684c088182d55810e4c6b0bbf4.pdf";